import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import Close from '@material-ui/icons/Close';
import Modal from '@material-ui/core/Modal';

export const centerEssentials = `
    display: flex;
    justify-content: center;
    align-items: center;
`

export const ModalTest = styled(Modal)`

    display: flex;
  justify-content: center;
  align-items: center;
`

export const CloseButton = styled(Close)`
    cursor:pointer;
`
export const xButton = styled(Button)`
    cursor:pointer;
`;

export const xSongButton = styled(Button)`
    padding:5px;
`;

export const flexColumn = `
    display: flex;
    flex-flow: column;
`;

export const flexRow = `
    display: flex;
    flex-flow: row;
`;

export const flexDirection = {
    column:{
        display:'flex',
        flexFlow:'column'
    },
    row:{
        display:'flex',
        flexFlow:'row'
    }
}

export const marginPixels = {
    threeBottom:{
        marginBottom:'3px'
    },
    threeRight:{
        marginRight:'3px'
    },
    five:{
        margin:'5px'
    },
    fiveBottom:{
        marginBottom:'5px'
    },
    fiveTop:{
        marginTop:'5px'
    }
}
export const SplitSides = styled.div`
    display:flex;
    justify-content: space-between;
`

export const AppButton = styled(Button)`
    background-color:#ff686b;
    border:none;
    color: #fff;
    font-weight: 500;
`

export const PrimaryButton = styled(AppButton)`
    background-color:#ff686b;
`

export const SecondaryButton = styled(AppButton)`
    background-color: #5d2627;
  `
  export const TertiaryButton = styled(AppButton)`
  background-color:#84dcc6;
  `

export const QuaternaryButton = styled(AppButton)`
background-color: #fc9f5b;
`
